/**
 * Category for Prettier's CLI.
 */
export const CATEGORY_PUG: string = 'Pug';
